import type { IxcPaymentsV1AchKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const PAYMENTS_ACH_BASE_PATH = getResolvedPath('/clearing/finance/payment/ach');

export const getPaymentsAchPath: EntityPathBuilder<IxcPaymentsV1AchKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return PAYMENTS_ACH_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.achId) {
        return undefined;
      }

      return getResolvedPath(`${PAYMENTS_ACH_BASE_PATH}/$achId`, context.keys);
    }
  }
};

export function getPaymentsAchDetailPath(achId: string | undefined) {
  if (!achId) {
    return undefined;
  }

  return getPaymentsAchPath({ kind: 'detail', keys: { achId } });
}
